import { render, staticRenderFns } from "./AppDocumentPreview.vue?vue&type=template&id=73c2805a&scoped=true&"
import script from "./AppDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./AppDocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AppDocumentPreview.vue?vue&type=style&index=0&id=73c2805a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2805a",
  null
  
)

export default component.exports